import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({}).set('Search', new Immutable.List([])).set('Response', new Immutable.Map({})).set('Get', new Immutable.Map({}))

/* Types */
export const ACTION_NEW_GROUP = 'ACTION_NEW_GROUP'

export const ACTION_SEARCH_GROUP = 'ACTION_SEARCH_GROUP'

export const ACTION_GET_GROUP = 'ACTION_GET_GROUP'

export const ACTION_DELETE_GROUP = 'ACTION_DELETE_GROUP'

export const ACTION_UPDATE_GROUP = 'ACTION_UPDATE_GROUP'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case ACTION_NEW_GROUP:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_SEARCH_GROUP:
			return state.set('Search', new Immutable.List(action.Obj))
		case ACTION_GET_GROUP:
			return state.set('Get', new Immutable.Map(action.Obj))
		case ACTION_DELETE_GROUP:
			return state.set('Response', new Immutable.Map(action.Obj))
		case ACTION_UPDATE_GROUP:
			return state.set('Response', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

/* Action Creators */

export const addGroup = (form) => {

	let data = Object.assign({}, form)
	data.donantesGrupo = Utils.getListPropsOmit(data.donantesGrupo, ['id', 'tmp'])
	data.donantesGrupoRemove = Utils.getListPropsOmit(data.donantesGrupoRemove, ['id'])
	data.donantesGrupo = Utils.unionArray(data.donantesGrupo, data.donantesGrupoRemove)

	data.gruposDonataria = Utils.getListPropsOmit(data.gruposDonataria, ['id', 'tmp'])
	data.gruposDonatariaRemove = Utils.getListPropsOmit(data.gruposDonatariaRemove, ['id'])
	data.gruposDonataria = Utils.unionArray(data.gruposDonataria, data.gruposDonatariaRemove)

	data.documentosFaseGrupo = Utils.getListPropsOmit(data.documentosFaseGrupo, ['id', 'tmp'])
	data.documentosFaseGrupoRemove = Utils.getListPropsOmit(data.documentosFaseGrupoRemove, ['id'])
	data.documentosFaseGrupo = Utils.unionArray(data.documentosFaseGrupo, data.documentosFaseGrupoRemove)

	data.fasesGrupo = Utils.getListPropsOmit(data.fasesGrupo, ['id', 'tmp'])
	data.fasesGrupoRemove = Utils.getListPropsOmit(data.fasesGrupoRemove, ['id'])
	data.fasesGrupo = Utils.unionArray(data.fasesGrupo, data.fasesGrupoRemove)

	data.objetivosDesarrolloGrupo = Utils.getListPropsOmit(data.objetivosDesarrolloGrupo, ['id', 'tmp'])
	data.objetivosDesarrolloGrupoRemove = Utils.getListPropsOmit(data.objetivosDesarrolloGrupoRemove, ['id'])
	data.objetivosDesarrolloGrupo = Utils.unionArray(data.objetivosDesarrolloGrupo, data.objetivosDesarrolloGrupoRemove)

	data.rubrosGrupo = Utils.getListPropsOmit(data.rubrosGrupo, ['id', 'tmp'])
	data.rubrosGrupoRemove = Utils.getListPropsOmit(data.rubrosGrupoRemove, ['id'])
	data.rubrosGrupo = Utils.unionArray(data.rubrosGrupo, data.rubrosGrupoRemove)

	data.evaluadoresGrupo = Utils.getListPropsOmit(data.evaluadoresGrupo, ['id', 'tmp'])
	data.evaluadoresGrupoRemove = Utils.getListPropsOmit(data.evaluadoresGrupoRemove, ['id'])
	data.evaluadoresGrupo = Utils.unionArray(data.evaluadoresGrupo, data.evaluadoresGrupoRemove)

	data.etapaFortalecimientoGrupo = Utils.getListPropsOmit(data.etapaFortalecimientoGrupo, ['id', 'tmp'])
	data.etapaFortalecimientoGrupoRemove = Utils.getListPropsOmit(data.etapaFortalecimientoGrupoRemove, ['id'])
	data.etapaFortalecimientoGrupo = Utils.unionArray(data.etapaFortalecimientoGrupo, data.etapaFortalecimientoGrupoRemove)

	data.tipoEvaluacionGrupo = Utils.getListPropsOmit(data.tipoEvaluacionGrupo, ['id', 'tmp'])
	data.tipoEvaluacionGrupoRemove = Utils.getListPropsOmit(data.tipoEvaluacionGrupoRemove, ['id'])
	data.tipoEvaluacionGrupo = Utils.unionArray(data.tipoEvaluacionGrupo, data.tipoEvaluacionGrupoRemove)

	data.consultorGrupo = Utils.getListPropsOmit(data.consultorGrupo, ['id', 'tmp'])
	data.consultorGrupoRemove = Utils.getListPropsOmit(data.consultorGrupoRemove, ['id'])
	data.consultorGrupo = Utils.unionArray(data.consultorGrupo, data.consultorGrupoRemove)

	data.objetivosDesarrolloGrupo = Utils.removeItem(data.objetivosDesarrolloGrupo, {idMeta: -1, idIndicador: -1})

	data.requisitosPagoGrupo = Utils.getListPropsOmit(data.requisitosPagoGrupo, ['id', 'tmp'])
	data.requisitosPagoGrupoRemove = Utils.getListPropsOmit(data.requisitosPagoGrupoRemove, ['id'])
	data.requisitosPagoGrupo = Utils.unionArray(data.requisitosPagoGrupo, data.requisitosPagoGrupoRemove)

	data.indicadoresGrupo = Utils.getListPropsOmit(data.indicadoresGrupo, ['id', 'tmp'])
	data.indicadoresGrupoRemove = Utils.getListPropsOmit(data.indicadoresGrupoRemove, ['id'])
	data.indicadoresGrupo = Utils.unionArray(data.indicadoresGrupo, data.indicadoresGrupoRemove)

	data.estatusComprobacionDonativo = Utils.getListPropsOmit(data.estatusComprobacionDonativo, ['id', 'tmp'])
	data.estatusComprobacionDonativoRemove = Utils.getListPropsOmit(data.estatusComprobacionDonativoRemove, ['id'])
	data.estatusComprobacionDonativo = Utils.unionArray(data.estatusComprobacionDonativo, data.estatusComprobacionDonativoRemove)

	data.contratoGrupo = Utils.getListPropsOmit(data.contratoGrupo, ['id', 'tmp'])
	data.contratoGrupoRemove = Utils.getListPropsOmit(data.contratoGrupoRemove, ['id'])
	data.contratoGrupo = Utils.unionArray(data.contratoGrupo, data.contratoGrupoRemove)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/newGroup',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then( () => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}

}

export const searchGroup = (form) => {

	Utils.clearNullAndEmpty(form)

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: Object.keys(form).length == 0 ? 'api/searchGroup' : 'api/searchParamGroup',
			method: "POST",
			data: {...form},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_SEARCH_GROUP, Obj: response.data })
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getGroup = (id) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/getGroup',
			method: "POST",
			data: { id },
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch({ type: ACTION_GET_GROUP, Obj: response.data})
			dispatch(isLoading(false))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const deleteGroup = () => {
	return (dispatch) => {
		return dispatch({ type: ACTION_DELETE_GROUP, Obj: {code: '', message: ''} });
	}
}

export const updateGroup = (form) => {

	let data = Object.assign({}, form)

	data.donantesGrupo = Utils.getListPropsOmit(data.donantesGrupo, ['id', 'tmp'])
	data.donantesGrupoRemove = Utils.getListPropsOmit(data.donantesGrupoRemove, ['id'])
	data.donantesGrupo = Utils.unionArray(data.donantesGrupo, data.donantesGrupoRemove)

	data.gruposDonataria = Utils.getListPropsOmit(data.gruposDonataria, ['id', 'tmp'])
	data.gruposDonatariaRemove = Utils.getListPropsOmit(data.gruposDonatariaRemove, ['id'])
	data.gruposDonataria = Utils.unionArray(data.gruposDonataria, data.gruposDonatariaRemove)

	data.documentosFaseGrupo = Utils.getListPropsOmit(data.documentosFaseGrupo, ['id', 'tmp'])
	data.documentosFaseGrupoRemove = Utils.getListPropsOmit(data.documentosFaseGrupoRemove, ['id'])
	data.documentosFaseGrupo = Utils.unionArray(data.documentosFaseGrupo, data.documentosFaseGrupoRemove)

	data.fasesGrupo = Utils.getListPropsOmit(data.fasesGrupo, ['id', 'tmp'])
	data.fasesGrupoRemove = Utils.getListPropsOmit(data.fasesGrupoRemove, ['id'])
	data.fasesGrupo = Utils.unionArray(data.fasesGrupo, data.fasesGrupoRemove)

	data.objetivosDesarrolloGrupo = Utils.getListPropsOmit(data.objetivosDesarrolloGrupo, ['id', 'tmp'])
	data.objetivosDesarrolloGrupoRemove = Utils.getListPropsOmit(data.objetivosDesarrolloGrupoRemove, ['id'])
	data.objetivosDesarrolloGrupo = Utils.unionArray(data.objetivosDesarrolloGrupo, data.objetivosDesarrolloGrupoRemove)

	data.rubrosGrupo = Utils.getListPropsOmit(data.rubrosGrupo, ['id', 'tmp'])
	data.rubrosGrupoRemove = Utils.getListPropsOmit(data.rubrosGrupoRemove, ['id'])
	data.rubrosGrupo = Utils.unionArray(data.rubrosGrupo, data.rubrosGrupoRemove)

	data.evaluadoresGrupo = Utils.getListPropsOmit(data.evaluadoresGrupo, ['id', 'tmp'])
	data.evaluadoresGrupoRemove = Utils.getListPropsOmit(data.evaluadoresGrupoRemove, ['id'])
	data.evaluadoresGrupo = Utils.unionArray(data.evaluadoresGrupo, data.evaluadoresGrupoRemove)

	data.etapaFortalecimientoGrupo = Utils.getListPropsOmit(data.etapaFortalecimientoGrupo, ['id', 'tmp'])
	data.etapaFortalecimientoGrupoRemove = Utils.getListPropsOmit(data.etapaFortalecimientoGrupoRemove, ['id'])
	data.etapaFortalecimientoGrupo = Utils.unionArray(data.etapaFortalecimientoGrupo, data.etapaFortalecimientoGrupoRemove)

	data.tipoEvaluacionGrupo = Utils.getListPropsOmit(data.tipoEvaluacionGrupo, ['id', 'tmp'])
	data.tipoEvaluacionGrupoRemove = Utils.getListPropsOmit(data.tipoEvaluacionGrupoRemove, ['id'])
	data.tipoEvaluacionGrupo = Utils.unionArray(data.tipoEvaluacionGrupo, data.tipoEvaluacionGrupoRemove)

	data.consultorGrupo = Utils.getListPropsOmit(data.consultorGrupo, ['id', 'tmp'])
	data.consultorGrupoRemove = Utils.getListPropsOmit(data.consultorGrupoRemove, ['id'])
	data.consultorGrupo = Utils.unionArray(data.consultorGrupo, data.consultorGrupoRemove)

	data.objetivosDesarrolloGrupo = Utils.removeItem(data.objetivosDesarrolloGrupo, {idMeta: -1, idIndicador: -1})

	data.requisitosPagoGrupo = Utils.getListPropsOmit(data.requisitosPagoGrupo, ['id', 'tmp'])
	data.requisitosPagoGrupoRemove = Utils.getListPropsOmit(data.requisitosPagoGrupoRemove, ['id'])
	data.requisitosPagoGrupo = Utils.unionArray(data.requisitosPagoGrupo, data.requisitosPagoGrupoRemove)

	data.indicadoresGrupo = Utils.getListPropsOmit(data.indicadoresGrupo, ['id', 'tmp'])
	data.indicadoresGrupoRemove = Utils.getListPropsOmit(data.indicadoresGrupoRemove, ['id'])
	data.indicadoresGrupo = Utils.unionArray(data.indicadoresGrupo, data.indicadoresGrupoRemove)

	data.estatusComprobacionDonativo = Utils.getListPropsOmit(data.estatusComprobacionDonativo, ['id', 'tmp'])
	data.estatusComprobacionDonativoRemove = Utils.getListPropsOmit(data.estatusComprobacionDonativoRemove, ['id'])
	data.estatusComprobacionDonativo = Utils.unionArray(data.estatusComprobacionDonativo, data.estatusComprobacionDonativoRemove)

	data.contratoGrupo = Utils.getListPropsOmit(data.contratoGrupo, ['id', 'tmp'])
	data.contratoGrupoRemove = Utils.getListPropsOmit(data.contratoGrupoRemove, ['id'])
	data.contratoGrupo = Utils.unionArray(data.contratoGrupo, data.contratoGrupoRemove)

	return (dispatch) => {
		dispatch(isLoading(true))
		dispatch({ type: ACTION_GET_GROUP, Obj: {} })

		return new ClientHttpRequest({
			service: 'api/updateGroup',
			method: "POST",
			data: {...data},
			headers: Object.assign({"Authorization": sessionStorage.access_token, "uid": sessionStorage.uid})
		}).request().then(response => {
			dispatch(isLoading(false))
			dispatch({ type: ACTION_UPDATE_GROUP, Obj: response.data })
			dispatch(createModal(Utils.successMessage()))
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}


export const clearGroup = () => {
	return (dispatch) => {
		dispatch({ type: ACTION_GET_GROUP, Obj: {} })
		dispatch({ type: ACTION_SEARCH_GROUP, Obj: []})
	}
}



// WEBPACK FOOTER //
// ./src/modules/Configurations/Groups/Config.js